import styled from "styled-components";
import { AppCouponItem } from "../../molecules/coupon/AppCouponItem";
import { AppCouponListFooter } from "../../organisms/AppCouponListFooter";
import { AppCouponMenuModal } from "../../organisms/modal/AppCouponMenuModal";
import { useAppCouponList } from "./hook";

export const AppCouponList: React.FC = () => {
  const {
    couponExternals,
    selectedCoupon,
    handleUseCoupon,
    handleOpenModal,
    handleCloseModal,
    handleReturn,
    getQuantityOfAppliedCoupon,
  } = useAppCouponList();

  return (
    <Container>
      <Title>アプリクーポン利用</Title>
      <Description>アプリクーポンを選択してください</Description>
      <LayoutContent>
        {Array.isArray(couponExternals) && couponExternals.length === 0 && (
          <NoItemsText>クーポンがありません</NoItemsText>
        )}

        {Array.isArray(couponExternals) && couponExternals.length > 0 && (
          <CouponListContainer>
            {couponExternals.map((coupon, index) => (
              <AppCouponItem
                key={`app-coupon-item-${coupon.code}-${index}`}
                coupon={coupon}
                isUsed={getQuantityOfAppliedCoupon(coupon) > 0}
                usedAmount={getQuantityOfAppliedCoupon(coupon)}
                onSelect={() => handleOpenModal(coupon)}
              />
            ))}
          </CouponListContainer>
        )}

        <AppCouponListFooter onReturn={handleReturn} />
      </LayoutContent>

      {selectedCoupon && !selectedCoupon.isTotalCoupon && (
        <AppCouponMenuModal
          isOpen={!!selectedCoupon}
          coupon={selectedCoupon ?? null}
          handleUse={handleUseCoupon}
          handleClose={handleCloseModal}
        />
      )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
`;

const Title = styled.div`
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 16px;
`;

const Description = styled.div`
  font-size: 16px;
  text-align: center;
  margin-bottom: 20px;
`;

const NoItemsText = styled.div`
  font-size: 16px;
  text-align: center;
  margin: 16px 0;
  padding: 50px 0;
`;

const CouponListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
`;

const LayoutContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  min-height: calc(100vh - 54px - 98px - 150px);
`;
